module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.countDownDate) ? _c('div', {
    staticClass: "count-down text-center w-100",
    class: {
      'count-down--expired': _vm.isCountdownExpired
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("COUNTDOWN")]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.header))]), _c('div', {
    staticClass: "row align-items-center justify-content-center no-gutters count-number mx-auto"
  }, [_c('div', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "block mx-auto"
  }, [_c('div', {
    staticClass: "digit text-center"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.days, _vm.compareDate)))]), _c('div', {
    staticClass: "text text-center"
  }, [_vm._v("DAYS")])])]), _c('div', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "block mx-auto"
  }, [_c('div', {
    staticClass: "digit text-center"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.hours, _vm.compareDate)))]), _c('div', {
    staticClass: "text text-center"
  }, [_vm._v("HOURS")])])]), _c('div', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "block mx-auto"
  }, [_c('div', {
    staticClass: "digit text-center"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.minutes, _vm.compareDate)))]), _c('div', {
    staticClass: "text text-center"
  }, [_vm._v("MINUTES")])])]), _c('div', {
    staticClass: "d-inline-block"
  }, [_c('div', {
    staticClass: "block mx-auto"
  }, [_c('div', {
    staticClass: "digit text-center"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.seconds, _vm.compareDate)))]), _c('div', {
    staticClass: "text text-center"
  }, [_vm._v("SECONDS")])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0028458","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/widgets/CountDown.vue
// module id = 1781
// module chunks = 1